import { render, staticRenderFns } from "./IconButtonsGroup.vue?vue&type=template&id=70ce2855&scoped=true&"
import script from "./IconButtonsGroup.vue?vue&type=script&lang=ts&"
export * from "./IconButtonsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./IconButtonsGroup.vue?vue&type=style&index=0&id=70ce2855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce2855",
  null
  
)

export default component.exports